export class Pages {
    value: string;
    dataTag: string;
    text: string;
}